import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/auth-redirect/$")({
    component: RouteComponent,
    beforeLoad: async ({ search, location }) => {
        throw redirect({
            to: "/ntimev1/$",
            params: { _splat: location.pathname },
            search,
        });
    },
});
function RouteComponent() {
    return null;
}
